import { render, staticRenderFns } from "./LabelGenView.vue?vue&type=template&id=489fe0ac"
import script from "./LabelGenView.vue?vue&type=script&lang=js"
export * from "./LabelGenView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports